<template>
  <div class="">
    <h2>{{ roughtext[locale][title] }}</h2>
    <h3 style="font-weight: normal" class="skill-subtitle">{{ rough.title }}</h3>
    <ExtraContent class="my-6" v-bind:contents="rough.extracontent" />
    <p class="mt-4" style="white-space: pre-line;">{{ rough.text }}</p>
    <v-radio-group v-model="result" :rules="rules[locale]">
      <v-radio
        v-for="(option, i) in rough.options"
        :key="i"
        :value="option.value"
      >
        <template slot="label">
          <label>
            <strong>
              {{ option.label.split("*")[0] }}
            </strong>
            {{ option.label.split("*")[1] }}
          </label>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import ExtraContent from "./ExtraContent.vue";
import { requiredRule } from "@/common/formRules.js";
export default {
  name: "RoughAssessment",
  props: {
    value: {
      type: String,
      required: true,
      default: ""
    },
    rough: {
      type: Object,
      required: true
    },
    locale: String
  },
  components: {
    ExtraContent
  },
  data() {
    return {
      rules: requiredRule,
      /*roughtext: {
        sv: {
          subtitle: "Ungefärlig nivå"
        },
        en: {
          subtitle: "Approximate level"
        },
        ar: {
          subtitle: "Approximate level"
        }
      }*/
      roughtext: {
        sv: {
          samtala: "SAMTALA",
          beratta: "BERÄTTA & PRESENTERA",
          lyssna: "LYSSNA",
          skriva: "SKRIVA",
          lasa: "LÄSA"
        },
        en: {
          samtala: "CONVERSATION",
          beratta: "INFORMING & PRESENTING",
          lyssna: "LISTENING",
          skriva: "WRITING",
          lasa: "READING"
        },
        ar: {
          samtala: "المحادثة",
          beratta: "التحدث والتقديم",
          lyssna: "الإصغاء",
          skriva: "الكتابة",
          lasa: "القراءة"
        }
      }
    };
  },
  computed: {
    title() {
      return this.$route.params.skill
    },
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

};
</script>

<style scoped>
li {
  list-style-type: "-";
  padding-inline-start: 1ch;
}
</style>
